// rolodex.component.ts
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemService } from '../item.service';
import { Item } from '../item.model';
import { CssPoint } from '../css-point';
import { CssValue } from '../css-value';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rolodex',
  templateUrl: './rolodex.component.html',
  styleUrls: ['./rolodex.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class RolodexComponent implements OnInit {
  private readonly startPoint: CssPoint;
  private readonly endPoint: CssPoint;
  private readonly unitVector: CssPoint;
  private tempPoint: CssPoint;
  private readonly magnitude: number;
  private readonly magnitudeScale: number;
  private runningTick: boolean;
  private lastTickTime: number;
  editMode = false;
  focusCard: any = null;

  constructor(private itemService: ItemService, private route: ActivatedRoute) {
    this.startPoint = new CssPoint(new CssValue(20, '%'), new CssValue(-100, '%'), new CssValue(-30000, 'px'));
    this.endPoint = new CssPoint(new CssValue(0, '%'), new CssValue(100, '%'), new CssValue(1000, 'px'));
    this.unitVector = new CssPoint(new CssValue(0, '%'), new CssValue(0, '%'), new CssValue(0, 'px'));
    this.tempPoint = new CssPoint(new CssValue(0, '%'), new CssValue(0, '%'), new CssValue(0, 'px'));
    this.unitVector.clone(this.endPoint);
    this.tempPoint.clone(this.startPoint);
    this.tempPoint.scale(-1.0);
    this.unitVector.add(this.tempPoint);
    this.magnitude = this.unitVector.mag();
    this.magnitudeScale = 1.0 / this.magnitude;
    this.unitVector.scale(this.magnitudeScale);

    this.touched = false;
    this.moving = false;
    this.rolodexCardStyle = [];
  }

  theItems: Item[];
  rolodexCardStyle: { [key: string]: any }[];
  cardIndex: number;

  private touched: boolean;
  private moving: boolean;

  triggerDistance = 50;
  kDrag = 0.001;
  kScreenConvert = 1.0 / 5000.0;
  kTouchForce = 0.00001;
  kTouchVelocityForce = 0.00005;
  tickTime = 1000.0 / 60.0;
  mass = 10.0;
  forceTouch = 0.0;
  lastTouchY = 0;
  maxVelocity = 0.0007;
  tickClock;
  velocity = 0.00010;
  offset = 0.0;
  rolodexDebugger: true;
  force: any;
  forceTouchVelocity: any;
  direction = 1.0;
  lastTouch = {x: 0, y: 0, time: 0};

  isEditing = false;
  editorIndex = -1;

  startEdit(index: number) {
    console.log('[Editor] Start edit for index:', index);
    this.editorIndex = index;
    this.isEditing = true;
    clearInterval(this.tickClock);
  }

  cancelEdit() {
    this.editorIndex = -1;
    this.isEditing = false;
    this.startRolodex();
  }

  positionTheCards() {
    const cardDelta = 1.0 / this.theItems.length;
    for (let index = 0; index < this.theItems.length; index++) {
      const multiplier = (this.offset + index * cardDelta) % 1.0;
      this.tempPoint.clone(this.unitVector);
      this.tempPoint.scale(multiplier * this.magnitude);
      const theZIndex = (this.focusCard && this.theItems[index] === this.focusCard) ? 999 : Math.floor(multiplier / cardDelta);
      this.rolodexCardStyle[index] = {
        transform: 'translate3d(' + this.startPoint.x.val + this.startPoint.x.units + ',' +
          this.startPoint.y.val + this.startPoint.y.units + ',' + this.startPoint.z.val + this.startPoint.z.units +
          ') translate3d(' + this.tempPoint.x.val + this.tempPoint.x.units + ',' +
          this.tempPoint.y.val + this.tempPoint.y.units + ',' + this.tempPoint.z.val + this.tempPoint.z.units + ')',
        'z-index': theZIndex
      };
    }
  }

  mouseStartEvent(event) {
    event.preventDefault();
    this.lastTouchY = event.clientY;
    this.touched = true;
  }

  mouseStopEvent(event) {
    this.touched = false;
    this.moving = false;
  }

  mouseMoveEvent(event) {
    if (this.touched) {
      this.lastTouch.time = Date.now();
      this.lastTouch.x = event.clientX;
      this.lastTouch.y = event.clientY;
      this.moving = true;
    }
  }

  touchStartEvent(event) {
    this.lastTouchY = event.changedTouches[0].clientY;
    this.touched = true;
  }

  touchStopEvent(event) {
    this.touched = false;
    this.moving = false;
  }

  touchMoveEvent(event) {
    this.lastTouch.time = Date.now();
    event.preventDefault();
    this.lastTouch.x = event.changedTouches[0].clientX;
    this.lastTouch.y = event.changedTouches[0].clientY;
    this.moving = true;
  }

  addEventHandlers() {
    const elem = document;
    elem.addEventListener('mousedown', this.mouseStartEvent.bind(this), false);
    elem.addEventListener('mouseup', this.mouseStopEvent.bind(this), false);
    elem.addEventListener('mousemove', this.mouseMoveEvent.bind(this), false);
    elem.addEventListener('touchstart', this.touchStartEvent.bind(this), false);
    elem.addEventListener('touchend', this.touchStopEvent.bind(this), false);
    elem.addEventListener('touchmove', this.touchMoveEvent.bind(this), false);
  }

  startRolodex() {
    this.addEventHandlers();
    this.runningTick = false;
    this.lastTickTime = Date.now();
    this.tickClock = setInterval(() => {
      this.rolodexTick();
    }, this.tickTime);
  }

  rolodexTick() {
    if (this.focusCard) return;
    const currentTickTime = Date.now();
    if (this.runningTick) return;
    this.runningTick = true;
    const currentTickDelta = currentTickTime - this.lastTickTime;
    this.lastTickTime = currentTickTime;

    const forceDrag = -1.0 * this.kDrag * this.velocity;

    let forceTouch = 0.0;
    let forceTouchVelocity = 0.0;
    if (this.touched) {
      if (this.velocity !== 0.0) {
        let sign = this.velocity > 0.0 ? -1.0 : 1.0;
        forceTouch = sign * this.kTouchForce;
      }
      if (this.moving) {
        const touchDistance = this.lastTouch.y - this.lastTouchY;
        this.lastTouchY = this.lastTouch.y;
        forceTouchVelocity = this.kTouchVelocityForce * touchDistance / currentTickDelta;
      }
    }

    const force = forceDrag + forceTouch + forceTouchVelocity;
    forceTouch = 0.0;

    const acceleration = force / this.mass;
    this.velocity += acceleration * currentTickDelta;
    let magVel = Math.abs(this.velocity);
    let velocitySign = Math.sign(this.velocity);

    if (magVel < 0.00001) this.velocity = 0.0;
    if (magVel > this.maxVelocity) this.velocity = this.maxVelocity * velocitySign;

    this.offset += this.velocity * currentTickDelta;
    if (this.offset < 0.0) this.offset += 1.0;
    this.offset %= 1.0;

    this.positionTheCards();
    this.runningTick = false;
  }

  ngOnInit(): void {
    this.itemService.getItems().subscribe(data => {
      this.theItems = data.map(changes => ({
        id: changes.payload.key,
        ...changes.payload.val()
      }) as Item);

      this.positionTheCards();
      this.startRolodex();
    });

    // check if in edit mode
    this.route.queryParams.subscribe(params => {
      this.editMode = params['edit'] === 'true';
      console.log('Edit mode:', this.editMode);
    });
  }

  create(item: Item) {
    this.itemService.createItem(item);
  }
  update(item: Item) {
    this.itemService.updateItem(item);
  }
  delete(id: string) {
    this.itemService.deleteItem(id);
  }

  getRolodexCardStyle(i: number) {
    return this.rolodexCardStyle[i] || {};
  }

  getRolodexCardTransform(i: number): string {
    return this.rolodexCardStyle[i].transform || '';
  }

  getRolodexCardZIndex(i: number): string {
    return '' + this.rolodexCardStyle[i]['z-index'];
  }

  isTransitioning = false;

  onCardClick(card: any, index: number, event: MouseEvent): void {
    event.stopPropagation();

    this.isTransitioning = true;

    if (this.focusCard === card) {
      setTimeout(() => {
        this.focusCard = null;
        this.isTransitioning = false;
      }, 500); // slightly longer than the transition
    } else {
      this.focusCard = card;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    }
  }
}
